import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { MicrophoneAccessHandler } from './services/handlers/microphone-access.handler';
import { MediaRecorderMicrophonePermissionProvider } from './services/providers/media-recorder-microphone-permission.provider';
import {
  MICROPHONE_ACCESS_HANDLER,
  MICROPHONE_PERMISSION_PROVIDER,
} from './tokens/voice-message.tokens';

/**
 * Il permesso del microfono e' del portale, non della chat: lo chiedono la chat e le impostazioni, e lo
 * mostrano tutte e due. Si registra alla radice, in un file suo, perche' importarlo non trascini la
 * dettatura che vive sulle rotte della chat.
 */
export function provideMicrophoneAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MICROPHONE_PERMISSION_PROVIDER,
      useClass: MediaRecorderMicrophonePermissionProvider,
    },
    { provide: MICROPHONE_ACCESS_HANDLER, useClass: MicrophoneAccessHandler },
  ]);
}
